// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Flex } from '../../../grid';
import {
  ProgressRowButton,
  ProgressRowPrice,
  CartHamburger,
} from './atoms';
import {
  getOrderLeaseObjectButtonText,
  getPerText,
  getMonthText,
  getPerMonthAbbrv,
} from '../../../../store/configuratorSettings/selectors';
import {
  getOrderLink,
} from '../../../../store/pdb/selectors';
import {
  CartSummaryComponent,
  CartHamburgerComponent,
} from './cartSummary.styled';
import withOnClickValidation from '../../../withOnClickValidation';

type OwnProps = {|
  price: number,
|};

type StateProps = {|
  orderButtonLink: ?string,
  orderButtonLabel: string,
  perText: string,
  monthText: string,
  perMonthAbbrv: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const ValidatedProgressButton = withOnClickValidation(ProgressRowButton);

const CartSummary = ({
  orderButtonLink,
  orderButtonLabel,
  price,
  perText,
  monthText,
  perMonthAbbrv,
}: Props) => (
  <Flex justifyContent="space-between" alignItems="center" flexWrap={false}>
    <CartSummaryComponent>
      <ProgressRowPrice
        amount={price}
        displayZeroes={false}
        displayCurrencySymbol={false}
        perMonth={`${perText} ${monthText}`}
        perMonthAbbrv={perMonthAbbrv}
      />
    </CartSummaryComponent>
    <CartSummaryComponent>
      {orderButtonLink && (
        <ValidatedProgressButton
          caret
          hasMargin={false}
          href={orderButtonLink}
          size="tiny"
        >
          {orderButtonLabel}
        </ValidatedProgressButton>
      )}
    </CartSummaryComponent>
    <CartHamburgerComponent>
      <CartHamburger isOpen={false} />
    </CartHamburgerComponent>
  </Flex>
);

const mapStateToProps = (state: any): StateProps => ({
  orderButtonLink: getOrderLink(state),
  orderButtonLabel: getOrderLeaseObjectButtonText(state),
  perText: getPerText(state),
  monthText: getMonthText(state),
  perMonthAbbrv: getPerMonthAbbrv(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(CartSummary);
